export class LogSourceLocationGcpCloudLogging {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "bucket",
            "baseName": "bucket",
            "type": "string",
            "format": ""
        },
        {
            "name": "prefix",
            "baseName": "prefix",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return LogSourceLocationGcpCloudLogging.attributeTypeMap;
    }
    constructor() {
    }
}
